import { Component } from "@angular/core";
import { UiService } from "../../../configuration/state/ui.service";

@Component({
	selector: "app-unit-list-widget-settings",
	template: `
		<app-widget-hide-from-dashboard-menu [onHide]="hide"></app-widget-hide-from-dashboard-menu>
	`,
})
export class UnitListWidgetSettingsComponent {
	constructor(private uiService: UiService) {}

	hide = () => {
		this.uiService.setWidgetVisibility("unitList", false);
	};
}
